import { useExperiment } from '~/systems/experiment';
import { shortcutDesc } from '~/util';
import IconButton from '../IconButton/IconButton';
import './UndoControl.css';

export default function UndoControl() {
  const experiment = useExperiment();
  return (
    <div className="UndoControl">
      <IconButton
        icon="undo"
        label={`Undo (${shortcutDesc('Z', true, false)})`}
        disabled={!experiment.undoStack.canUndo()}
        onClick={experiment.undoStack.undo}
      />
      <IconButton
        icon="redo"
        label={`Redo (${shortcutDesc('Z', true, true)})`}
        disabled={!experiment.undoStack.canRedo()}
        onClick={experiment.undoStack.redo}
      />
    </div>
  );
}
